import { useLocation } from "react-router-dom";
import LegalNav from "./LegalNav.jsx";
import Typo from "./LegalTypography.jsx";

const H3 = ({ children }) => <Typo variant="h3-bold">{children}</Typo>;

export default function PrivacyPage() {
  const isMobile =
    new URLSearchParams(useLocation().search).get("viewmode") === "mobile";
  return (
    <div className="min-h-screen bg-white">
      <LegalNav />
      <main
        className={`max-w-[944px] mx-auto px-5 ${isMobile ? "" : "pt-[52px]"}`}
      >
        <div className="pt-14 pb-20">
          <Typo variant="h1">
            Chính sách bảo mật
          </Typo>

          <Typo variant="p">
            Nebula ("Chúng tôi", "Ứng dụng") cam kết bảo vệ quyền riêng tư và dữ
            liệu cá nhân của bạn ("Người dùng"). Chính sách bảo mật này mô tả
            cách chúng tôi thu thập, sử dụng, lưu trữ và chia sẻ thông tin của
            bạn khi bạn sử dụng các tính năng của Nebula.
          </Typo>
          <Typo variant="p" mb="mb-8">
            Bằng việc sử dụng Nebula, bạn đồng ý với các điều khoản được nêu
            trong Chính sách này. Nếu bạn không đồng ý với các điều khoản của
            chính sách này, vui lòng ngừng sử dụng Nebula.
          </Typo>

          {/* I */}
          <Typo variant="h2">I. Thông tin chúng tôi thu thập</Typo>
          <Typo variant="p">
            Để cung cấp cho bạn những trải nghiệm sử dụng Website/App Nebula một
            cách tốt nhất, chúng tôi thu thập 3 loại thông tin sau:
          </Typo>
          <Typo variant="ul">
            <Typo variant="li">Thông tin do bạn trực tiếp cung cấp</Typo>
            <Typo variant="li">Thông tin nhận được từ bên thứ ba</Typo>
            <Typo variant="li">Thông tin được thu thập tự động.</Typo>
          </Typo>

          {/* II */}
          <Typo variant="h2">
            II. Chúng tôi thu thập thông tin cá nhân như thế nào?
          </Typo>

          <H3>1. Thông tin cá nhân được bạn cung cấp</H3>
          <Typo variant="p">
            Đăng ký tài khoản. Nếu bạn đăng ký tài khoản thông qua trang web,
            ứng dụng của chúng tôi hoặc thông qua một thỏa thuận đăng ký riêng
            với chúng tôi, thì như một phần của quá trình đăng ký đó, chúng tôi
            sẽ yêu cầu bạn cung cấp một số dữ liệu cá nhân nhất định, bao gồm:
          </Typo>
          <Typo variant="ul">
            <Typo variant="li">Tên của bạn</Typo>
            <Typo variant="li">Tên công ty</Typo>
            <Typo variant="li">Địa chỉ email và mật khẩu</Typo>
            <Typo variant="li">
              Nếu bạn tạo tài khoản hoặc đăng nhập vào website/app bằng các dịch
              vụ của bên thứ ba, chẳng hạn như Google, Facebook chúng tôi sẽ
              nhận được tên và địa chỉ email và/hoặc số điện thoại của bạn như
              được cho phép bởi cài đặt hồ sơ của bạn trên dịch vụ bên thứ ba
              trong để xác thực bạn
            </Typo>
          </Typo>
          <Typo variant="p">
            Thông tin chúng tôi nhận được khi bạn xác thực thông qua dịch vụ của
            bên thứ ba tùy thuộc vào cài đặt, quyền và chính sách bảo mật do
            dịch vụ của bên thứ ba đó kiểm soát. Bạn cần kiểm tra cài đặt quyền
            riêng tư cũng như thông báo trong các dịch vụ của bên thứ ba có liên
            quan để hiểu dữ liệu nào có thể được tiết lộ cho chúng tôi hoặc chia
            sẻ với website/app của Nebula.
          </Typo>
          <Typo variant="p">
            Giao tiếp với Nebula. Chúng tôi thu thập dữ liệu cá nhân mà bạn tự
            nguyện cung cấp cho chúng tôi khi bạn liên hệ với chúng tôi khi có
            thắc mắc (bao gồm bằng cách điền vào các biểu mẫu / live chat có
            liên quan trên trang web/ứng dụng của chúng tôi), tương tác với
            bot/AI chat trò chuyện của chúng tôi trên trang web/ứng dụng (bao
            gồm lịch sử trò chuyện, các câu hỏi, lựa chọn tương tác, phản hồi),
            trả lời một trong các khảo sát của chúng tôi, liên hệ với bộ phận hỗ
            trợ khách hàng của chúng tôi về một vấn đề bạn đang gặp phải Dịch vụ
            hoặc liên hệ với chúng tôi về trang web/ứng dụng hoặc Dịch vụ.
          </Typo>
          <Typo variant="p">
            Thông tin thanh toán. Chúng tôi thu thập thông tin thanh toán và lập
            hóa đơn khi bạn đăng ký một số Dịch vụ phải trả phí.
          </Typo>

          <H3>2. Thông tin cá nhân được cung cấp từ bên thứ 3</H3>
          <Typo variant="p">
            Chúng tôi có thể kết hợp dữ liệu cá nhân mà chúng tôi nhận được từ
            bạn với dữ liệu cá nhân mà chúng tôi có được từ các nguồn khác,
            chẳng hạn như các mạng xã hội: facebook, google, twitter… Những dịch
            vụ này sẽ cung cấp một số thông tin như: email, số điện thoại để
            liên kết với tài khoản của bạn trên dịch vụ của chúng tôi. Chúng tôi
            không kiểm soát cũng như chịu trách nhiệm về cách thức bên thứ 3 xử
            lý dữ liệu của bạn.
          </Typo>

          <H3>3. Thông tin cá nhân thu thập tự động</H3>
          <Typo variant="p">
            Giống như rất nhiều website/app khác chúng tôi sử dụng các công cụ
            thu thập dữ liệu với mục đích nâng cao trải nghiệm người dùng, giúp
            sản phẩm của chúng tôi ngày càng hoàn thiện hơn như: IP, loại thiết
            bị, hệ điều hành, dữ liệu sử dụng ứng dụng, cookies, web beacons,
            pixels, và một số công nghệ tương tự. Những thông tin này được thu
            thập tự động khi bạn truy cập vào website/app của chúng tôi.
          </Typo>

          {/* III */}
          <Typo variant="h2">III. Cách chúng tôi sử dụng thông tin</Typo>

          <H3>
            1. Chúng tôi sử dụng các dữ liệu cá nhân đã được mô tả ở trên như
            sau:
          </H3>
          <Typo variant="p">
            Cung cấp các tính năng cốt lõi và hỗ trợ liên quan, xử lý giao dịch,
            quản lý tài khoản người dùng của bạn và đáp ứng các yêu cầu của bạn.
            Điều này là cần thiết để thực hiện việc chúng tôi sắp cung cấp dịch
            vụ hoặc đã cung cấp dịch vụ với bạn.
          </Typo>
          <Typo variant="p">
            Trong phạm vi được pháp luật nước Cộng Hòa Xã Hội Chủ Nghĩa Việt Nam
            cho phép và vì một số lợi ích hợp pháp nhất định. Bao gồm:
          </Typo>
          <Typo variant="ul">
            <Typo variant="li">
              Cung cấp cho bạn những nội dung bạn yêu cầu đối với dịch vụ của
              chúng tôi.
            </Typo>
            <Typo variant="li">
              Kết nối với bạn. Bao gồm các thông tin cập nhật dịch vụ, thông tin
              thị trường…
            </Typo>
            <Typo variant="li">
              Phân tích hành vi của bạn trong quá trình sử dụng website/app,
              điều này sẽ giúp chúng tôi nâng cao chất lượng dịch vụ.
            </Typo>
          </Typo>
          <Typo variant="p">
            Để cung cấp tính năng AI Chat, chúng tôi có thể sử dụng các API của
            bên thứ ba (ví dụ: OpenAI, Anthropic, Google…). Dữ liệu văn bản bạn
            nhập vào có thể được xử lý bởi các đối tác này. Tuy nhiên, chúng tôi
            đảm bảo dữ liệu gửi đi đã được ẩn danh hóa và các đối tác này không
            được phép sử dụng dữ liệu cá nhân của bạn để huấn luyện mô hình ngôn
            ngữ chung của họ.
          </Typo>
          <Typo variant="p">
            Để tiếp thị và quảng cáo, bao gồm gửi cho bạn các bản cập nhật và
            thông tin về các sản phẩm và dịch vụ mới của chúng tôi, các sự kiện
            sắp tới hoặc các chương trình khuyến mãi hoặc tin tức khác, bao gồm
            cả qua email hoặc thông báo, theo luật hiện hành cho phép.
          </Typo>

          <H3>2. Chúng tôi chia sẻ thông tin cá nhân như thế nào?</H3>
          <Typo variant="p">
            Chúng tôi chia sẻ thông tin cá nhân của bạn với các bên thứ 3 theo
            những trường hợp sau:
          </Typo>
          <Typo variant="ul">
            <Typo variant="li">
              Khi có sự yêu cầu của các cơ quan chức năng theo luật hiện hành
              của Nước CHXHVN Việt Nam.
            </Typo>
            <Typo variant="li">
              Các nhà cung cấp dịch vụ. Nebula giống như rất nhiều doanh nghiệp
              khác trên thế giới, chúng tôi ký kết với các bên thứ 3 để hỗ trợ
              chúng tôi trong các hoạt động, chẳng hạn như: dịch vụ thanh toán
              thẻ hoặc thanh toán, đối tác cung cấp dịch vụ lưu trữ dữ liệu
              CNTT, nhà cung cấp dịch vụ quảng cáo…
            </Typo>
            <Typo variant="li">
              Thông tin thanh toán. Người dùng trả phí cần cung cấp thông tin
              thanh toán. Thông tin này được cung cấp cho những đối tác thanh
              toán của chúng tôi bao gồm nhưng không giới hạn OnePay và VNPAY.
              Khi bạn thanh toán, chúng tôi không có quyền truy cập vào thông
              tin cá nhân và/hoặc thẻ tín dụng của bạn. Nếu chúng tôi có bất kỳ
              vấn đề nào với việc xử lý đơn đặt hàng, địa chỉ email bạn đã cung
              cấp sẽ được sử dụng để liên hệ với bạn.
            </Typo>
          </Typo>
          <Typo variant="p">
            Nhà cung cấp nội dung bên thứ ba. Khi bạn mua dịch vụ/ sản phẩm từ
            các sàn giao dịch chứng khoán, chúng tôi cung cấp cho họ chi tiết
            liên hệ, số điện thoại, địa chỉ và email của bạn và bạn ký thỏa
            thuận. Dữ liệu này cũng được xử lý bởi các sàn giao dịch chứng khoán
            để cung cấp cho bạn quyền truy cập vào các sàn giao dịch.
          </Typo>
          <Typo variant="p">
            Nhà môi giới. Khi bạn điền vào biểu mẫu Mở tài khoản cho nhà môi
            giới, chúng tôi sẽ gửi cho họ dữ liệu cá nhân của bạn được điền vào
            biểu mẫu này: họ và tên, số điện thoại, địa chỉ email, quốc gia. Dữ
            liệu này được nhà môi giới xử lý để mở tài khoản môi giới của bạn.
          </Typo>
          <Typo variant="p">
            Nhà cung cấp dịch vụ phân tích. Chúng tôi sử dụng dịch vụ phân tích
            từ bên thứ 3 để theo dõi và phân tích dữ liệu từ website/app. Chúng
            tôi sử dụng các dịch vụ này để cải thiện dịch vụ với mục đích nâng
            cao trải nghiệm của bạn trong tương lai. Chúng tôi sử dụng Google
            Analytics (hoặc dịch vụ khác tương tự nếu có) như một dịch vụ phân
            tích web trên Trang web và kết hợp với các tiện ích mà chúng tôi
            cung cấp. Để biết thêm thông tin về các nguyên tắc bảo mật của
            Google Analytics, bạn có thể kiểm tra tại: Safeguarding your data -
            Analytics Help{" "}
            <a
              href="https://support.google.com/analytics/answer/6004245?hl=en&ref_topic=2919631"
              target="_blank"
              rel="noopener noreferrer"
              className="text-[#006CEC] hover:underline"
            >
              Safeguarding your data – Analytics Help
            </a>
            .
          </Typo>
          <Typo variant="p">
            Quảng cáo: Chúng tôi hiển thị quảng cáo trên Website và có thể sử
            dụng các tính năng theo dõi và tiếp thị lại. Các tính năng Tiếp thị
            lại cho phép chúng tôi hiển thị quảng cáo theo cách được nhắm mục
            tiêu hơn để hiển thị quảng cáo mà người dùng quan tâm, dựa trên hoạt
            động của họ trên các trang web khác. Dữ liệu này cũng giúp chúng tôi
            đánh giá hiệu suất của các chiến dịch quảng cáo. Lưu ý rằng chúng
            tôi chỉ thu thập dữ liệu giả lập. Chúng tôi có thể sử dụng các dịch
            vụ sau cho mục đích quảng cáo, tiếp thị lại và theo dõi:
          </Typo>
          <Typo variant="ul">
            <Typo variant="li">
              Quảng cáo Google. Giúp chúng tôi quảng cáo dịch vụ trên các ứng
              dụng và đối tác của google. Để biết thêm thông tin cách google sử
              dụng dữ liệu vui lòng truy cập trang chính sách và điều khoản
              google tại:{" "}
              <a
                href="https://policies.google.com/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#006CEC] hover:underline"
              >
                Privacy & Terms – Google
              </a>
            </Typo>
            <Typo variant="li">
              Facebook Pixel. Cho phép chúng tôi đo lường, tối ưu chất lượng
              quảng cáo và xây dựng cộng đồng cho các chiến dịch quảng cáo. Bạn
              có thể tìm hiểu chính sách quyền riêng tư của Facebook tại:{" "}
              <a
                href="https://www.facebook.com/privacy/policy"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#006CEC] hover:underline"
              >
                Meta Privacy Policy - How Meta collects and uses user data
              </a>
            </Typo>
          </Typo>

          <H3>3. Chúng tôi bảo vệ thông tin như thế nào?</H3>
          <Typo variant="p">
            Chúng tôi sử dụng các biện pháp bảo vệ vật lý cũng như công nghệ để
            bảo vệ dữ liệu cá nhân của bạn và cũng yêu cầu các đối tác đáp ứng
            tiêu chuẩn bảo vệ tương tự.
          </Typo>
          <Typo variant="p">
            Chúng tôi sử dụng công nghệ mã hóa TLS ({" "}
            <a
              href="https://www.cloudflare.com/learning/ssl/transport-layer-security-tls/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-[#006CEC] hover:underline"
            >
              Transport Layer Security
            </a>{" "}
            ) để bảo vệ thông tin nhất định mà bạn gửi cho chúng tôi. Công nghệ
            này đảm bảo dữ liệu của bạn không bị ngăn chặn hoặc đánh cắp bởi bất
            kỳ ai trong quá trình truyền dữ liệu tới Nebula hoặc các đối tác
            thanh toán.
          </Typo>
          <Typo variant="p">
            Chúng tôi cũng sử dụng các công nghệ bảo mật khác như: tường lửa, hệ
            thống xác thực và các cơ chế kiểm soát truy cập để bảo vệ thông tin
            khỏi những kẻ truy cập trái phép. Chúng tôi luôn nỗ lực hết sức để
            đảm bảo website/app của chúng tôi đảm bảo tiêu chuẩn bảo mật ngành.
          </Typo>
          <Typo variant="p">
            Bảo mật dữ liệu Offline: Phòng lưu trữ dữ liệu của chúng tôi được
            lưu trữ tại một điểm điểm riêng biệt, chỉ những nhân viên cần xem
            thông tin với mục đích công việc mới có quyền truy cập.
          </Typo>
          <Typo variant="p">
            Chúng tôi liên tục cải thiện các tính năng bảo mật, tuy nhiên trong
            thế giới internet không có gì đảm bảo an toàn 100%. Do đó, chúng tôi
            cũng cần bạn có trách nghiệm bảo mật dữ liệu cá nhân của mình.
          </Typo>

          <H3>4. Dữ liệu Trẻ em</H3>
          <Typo variant="p">
            Website/App của chúng tôi không hướng đến nhóm trẻ em dưới 18 tuổi.
            Chúng tôi không có ý thu thập thông tin của những người dưới 18 tuổi
            và các dữ liệu nhạy cảm (như: tôn giáo, chính trị, dữ liệu sức khỏe,
            tình dục, dữ liệu sinh trắc học…). Nếu bạn tin rằng chúng tôi vô
            tính thu thập những thông tin trên, vui lòng liên hệ với chúng tôi
            ngay để xóa những thông tin này.
          </Typo>

          <H3>5. Xoá tài khoản</H3>
          <Typo variant="p">
            Các tài khoản trên trang web này có thể được xóa theo yêu cầu của
            người dùng. Vui lòng truy cập{" "}
            <a
              href="https://simplize.vn/delete-account"
              className="text-[#006CEC] hover:underline"
            >
              vào đây
            </a>{" "}
            để tiến hành xoá tài khoản. Xin lưu ý rằng việc xóa tài khoản sẽ dẫn
            đến việc xóa tất cả dữ liệu cá nhân và không thể khôi phục được
          </Typo>

          {/* Liên hệ */}
          <Typo variant="h2">Liên hệ</Typo>
          <Typo variant="p">Mọi thắc mắc hay yêu cầu hỗ trợ xin liên hệ:</Typo>
          <Typo variant="p" mb="mb-1">
            <Typo variant="strong">CÔNG TY CỔ PHẦN SIMPLIZE</Typo>
          </Typo>
          <Typo variant="p" mb="mb-1">
            Trụ sở chính: Số 25 ngõ 198 Thái Hà, phường Đống Đa, TP.Hà Nội, Việt
            Nam
          </Typo>
          <Typo variant="p" mb="mb-1">
            Văn phòng giao dịch: Số 5 ngõ 316 Lê Trọng Tấn, phường Phương Liệt,
            TP. Hà Nội, Việt Nam
          </Typo>
          <Typo variant="p" mb="mb-1">
            Mã số thuế: 0109620361
          </Typo>
          <Typo variant="p" mb="mb-1">
            <Typo variant="semibold">Email:</Typo>{" "}
            <a
              href="mailto:info@simplize.vn"
              className="text-[#006CEC] hover:underline"
            >
              info@simplize.vn
            </a>
          </Typo>
          <Typo variant="p" mb="">
            Điện thoại: +84 38 840 8668
          </Typo>
        </div>
      </main>
    </div>
  );
}
